import {
  IProject,
  IProjectAward,
  IProjectBusiness,
  IProjectConcept,
  IProjectInnovation,
  IProjectOpportunity,
  IProjectPerson,
  IProjectUser,
} from 'app/models/project.d'
import {ISavedSearchFE} from 'interfaces/ISavedSearchFE'
import {ProjectTypesDS} from 'utilities/projectTypes'
import {JsonObject} from 'utilities/types'
import {INote} from '../'
import {CBaseRecord} from './_base'
import {mapAndSort} from './_utils'
import {CAward} from './award'
import {CBusiness} from './business'
import {CConcept} from './concept'
import {CInnovation} from './innovation'
import {CNote} from './note'
import {COpportunity} from './opportunity'
import {CPerson} from './person'
import {CSavedSearch} from './saved_search'
import {CUser} from './user'

export class CProjectUser extends CUser implements IProjectUser {
  __role

  constructor(data: IProjectUser & JsonObject) {
    super(data)
    this.__role = data.__role
  }
}

export class CProjectAward extends CAward implements IProjectAward {
  __step_id
  __connections
  __search_id

  constructor(data: IProjectAward & JsonObject) {
    super(data)
    this.__step_id = data.__step_id
    this.__connections = data.__connections
    this.__search_id = data.__search_id
  }
}

export class CProjectInnovation extends CInnovation implements IProjectInnovation {
  __step_id

  constructor(data: IProjectInnovation & JsonObject) {
    super(data)
    this.__step_id = data.__step_id
  }
}

export class CProjectOpportunity extends COpportunity implements IProjectOpportunity {
  __step_id

  constructor(data: IProjectOpportunity & JsonObject) {
    super(data)
    this.__step_id = data.__step_id
  }
}

export class CProjectPerson extends CPerson implements IProjectPerson {
  __step_id

  constructor(data: IProjectAward & JsonObject) {
    super(data)
    this.__step_id = data.__step_id
  }
}

export class CProjectBusiness extends CBusiness implements IProjectBusiness {
  __step_id
  __connections
  __search_id

  constructor(data: IProjectBusiness & JsonObject) {
    super(data)
    this.__step_id = data.__step_id
    this.__connections = data.__connections
    this.__search_id = data.__search_id
  }
}

export class CProjectConcept extends CConcept implements IProjectConcept {
  __step_id

  constructor(data: IProjectConcept & JsonObject) {
    super(data)
    this.__step_id = data.__step_id
  }
}

export class CProject extends CBaseRecord<IProject> implements IProject {
  static record_name = 'project'
  static external_id = 'project_id'
  static children = {
    awards: CAward,
    businesses: CBusiness,
    concepts: CConcept,
    saved_searches: CSavedSearch,
    notes: CNote,
    users: CUser,
    persons: CPerson,
    innovations: CInnovation,
    opportunities: COpportunity,
  }

  description
  name
  project_type
  proposals
  tenant_id
  awards
  businesses
  concepts
  saved_searches
  users
  notes
  persons
  innovations
  opportunities

  constructor(data: JsonObject & IProject) {
    super(data)
    this.id = data.id ?? ''
    this.name = data.name ?? 'New Project'
    this.project_type =
      ProjectTypesDS.find((f) => f.id === data.project_type)?.id ?? ProjectTypesDS[0].id ?? ''
    this.proposals = data.proposals ?? []
    this.tenant_id = (data as IProject).tenant_id ?? ''
    this.description = data.description ?? ''
    this.saved_searches =
      data.saved_searches?.map(
        (x) => new CSavedSearch(x as unknown as ISavedSearchFE & JsonObject)
      ) || undefined
    this.concepts = data.concepts?.map(
      (x) => new CProjectConcept(x as unknown as IProjectConcept & JsonObject)
    )
    this.businesses = data.businesses?.map(
      (x) => new CProjectBusiness(x as unknown as IProjectBusiness & JsonObject)
    )
    this.awards = data.awards?.map(
      (x) => new CProjectAward(x as unknown as IProjectAward & JsonObject)
    )
    //added persons since the api started sending it thru, instead of refactoring backend and frontend, should have never used people I think
    this.persons =
      data.persons?.map((x) => new CProjectPerson(x as unknown as IProjectPerson & JsonObject)) ??
      data.people?.map((x) => new CProjectPerson(x as unknown as IProjectPerson & JsonObject))
    this.innovations = data.innovations?.map(
      (x) => new CProjectInnovation(x as unknown as IProjectInnovation & JsonObject)
    )
    this.opportunities = data.opportunities?.map(
      (x) => new CProjectOpportunity(x as unknown as IProjectOpportunity & JsonObject)
    )
    this.users =
      data.users?.map((x) => new CProjectUser(x as unknown as IProjectUser & JsonObject)) ?? []
    this.notes = data.notes?.map((x) => new CNote(x as unknown as INote & JsonObject)) ?? []
  }

  export() {
    return {
      id: this.id,
      name: this.name,
      project_type: this.project_type,
      proposals: this.proposals,
      tenant_id: this.tenant_id,
      description: this.description,
      saved_searches: mapAndSort(this.saved_searches, (x) => x.export(), 'id'),
      concepts: mapAndSort(this.concepts, (x) => x.export(), 'id'),
      businesses: mapAndSort(this.businesses, (x) => JSON.parse(JSON.stringify(x)), 'id'),
      awards: mapAndSort(this.awards, (x) => JSON.parse(JSON.stringify(x)), 'id'),
      notes: mapAndSort(this.notes, (x) => JSON.parse(JSON.stringify(x)), 'id'),
      persons: mapAndSort(this.persons, (x) => JSON.parse(JSON.stringify(x)), 'id'),
      innovations: mapAndSort(this.innovations, (x) => JSON.parse(JSON.stringify(x)), 'id'),
      opportunities: mapAndSort(this.innovations, (x) => JSON.parse(JSON.stringify(x)), 'id'),
    }
  }

  stringify() {
    return JSON.stringify(this.export())
  }
}
